<div class="card modern-card">
  <!-- Header -->
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">
          <i class="fa-solid fa-cart-shopping me-2 icon-header"></i>
          Purchase Optimizer
        </h1>
      </div>
      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="openVendorDashboard()"
          title="Close"
          >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body p-4 d-flex flex-column" style="flex: 1; overflow-y: auto;">
    <!-- Optimized Purchases Header -->
    <div class="action-bar d-flex justify-content-between align-items-center mb-2 bg-dark-subtle p-2 px-3 rounded-3">
      <h2 class="text-light mb-0" style="font-size: 1.15rem; font-weight: 500;">
        <i class="fa-solid fa-magic me-2 icon-header"></i>
        Optimizations
      </h2>
      <div class="d-flex gap-2">
        <button
          class="btn red-btn btn-sm shadow-sm"
          (click)="refreshData()"
          title="Refresh Data"
          >
          <i class="fa-solid fa-arrows-rotate"></i> Refresh
        </button>
        <button
          class="btn grey-btn btn-sm shadow-sm"
          (click)="resetOptimizer()"
          title="Reset Optimizations"
          >
          <i class="fa-solid fa-rotate-left me-2"></i>
          Reset
        </button>
        <button
          class="btn green-btn btn-sm shadow-sm"
          (click)="optimizeOrder()"
          >
          <i class="fa-solid fa-file-invoice-dollar me-2"></i>
          Optimize Order
        </button>
        <button
          class="btn grey-btn btn-sm shadow-sm"
          (click)="addItem()"
          >
          <i class="fa-solid fa-plus me-2"></i>
          Add Item
        </button>
      </div>
    </div>

    <!-- Optimization Grid -->
    <div style="flex: 1; min-height: 0; margin-bottom: 10px; display: flex; flex-direction: column;">
      <ag-grid-angular
        #optimizerGrid
        id="optimizer-grid"
        class="modern-grid mb-4"
        style="width: 100%; height: 100%"
        
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        [rowData]="rowData"
        (gridReady)="onGridReady($event)"
        [animateRows]="true"
        [rowSelection]="rowSelection"
        [components]="components"
        >
      </ag-grid-angular>
    </div>

    <!-- Loading State Message -->
    @if (loading) {
      <div class="vendor-summaries-container vendor-totals-container bg-dark border border-secondary rounded p-4 text-center">
        <div class="d-flex flex-column align-items-center">
          <div class="spinner-border text-light mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h3 class="text-light modern-header mb-0" style="font-size: 1.25rem;">
            <i class="fa-solid fa-gear fa-spin me-2"></i>
            {{ loadingMessage }}
          </h3>
        </div>
      </div>
    }

    <!-- Vendor Summaries 1E1E1E-->
    @if (vendorTotals.length > 0 && !loading) {
      <div class="vendor-summaries-container vendor-totals-container mt-4 bg-dark border border-secondary rounded p-3">
        <h3 class="text-white mb-3" style="font-size: 1.1rem;"><i class="fa-solid fa-receipt me-2 icon-header"></i> Vendor Totals</h3>
        <div class="row g-3">
          @for (vt of vendorTotals; track vt) {
            <div class="col-md-6 col-lg-3">
              <div class="card bg-secondary text-white shadow-sm border-0">
                <div class="card-body p-3">
                  <h5 class="card-title fw-medium text-secondary border-bottom border-light pb-2 mb-2">{{ vt.vendor }}</h5>
                  <div class="d-flex justify-content-between mb-1">
                    <span>Items:</span>
                    <span>{{ vt.itemTotal | currency }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-1">
                    <span>Shipping:</span>
                    <span>{{ vt.shipping | currency }}</span>
                  </div>
                  <div class="d-flex justify-content-between fw-medium pt-1 border-top border-light mt-2">
                    <span>Total:</span>
                    <span>{{ vt.orderTotal | currency }}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

  </div>
</div>
